module.exports = __webpack_public_path__ + "static/media/photo51.f5dbcf52.jpg";